import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import DrawerMenuWidget from "../../core/widgets/DrawerMenuWidget/DrawerMenuWidget.js";
import ForecastLoadingWidget from "../../core/widgets/ForecastLoadingWidget/ForecastLoadingWidget.js";
import ForecastViewerDocumentContent from "./ForecastViewerDocumentContent/ForecastViewerDocumentContent.js";
import ForecastViewerDocumentCoordinator from "./ForecastViewerDocumentCoordinator.js";
import ForecastViewerDocumentService from "./ForecastViewerDocumentService.js";
import ForecastViewerDocumentState from "./ForecastViewerDocumentState.js";
import ForecastViewerTitleWidget from "./widgets/ForecastViewerTitleWidget/ForecastViewerTitleWidget.js";
import session from "../../core/session.js";

/**
 * This function creates and returns a new forecast viewer document and
 * everything that this document requires.
 */
export default function makeForecastViewerDocument() {
	const coordinator = new ForecastViewerDocumentCoordinator({
		documentState: new ForecastViewerDocumentState({
			service: new ForecastViewerDocumentService({ session }),
		}),
		renderables: {
			content: new ForecastViewerDocumentContent(),
			title: new ForecastViewerTitleWidget(),
			drawer: new DrawerMenuWidget(),
			periodPicker: false,
		},
	});

	return new AccountingDocument({
		coordinator,
		cssClass: "forecast-report forecast-viewer",
		spinner: new ForecastLoadingWidget({
			title: _("We are about to show you the future"),
			subtitle: _("Are you ready for this?"),
		}),
	});
}
